export default {"src":"/_next/static/image/public/images/ic_location_bg_white.a2840200687f92605bd243070c442f2c.svg","height":32,"width":32};